import enumTherapistsType from 'enums/enum-therapists-type';

export const getAppointmentHeaderText = ({ examerType }) => {
  return (
    <>
      {(() => {
        switch (examerType) {
          case enumTherapistsType.examer:
            return (
              <div>
                <h1 style={{ textAlign: 'center', color: '#4a80db' }}>
                  פגישה עם בודק
                </h1>
                <p style={{ fontSize: '18px' }}>
                  ברכות על תחילת תכנית WELLCHECK לקידום הבריאות האישית שלך במסך
                  זה, ניתן לתאם את מועד הגעת הבודק במקום ובזמן שנוח לך הבודק
                  יגיע אל מקום הפגישה עם הציוד הנדרש, כל שעלייך לעשות זה להיות
                  בזמן ובמקום :) השאר עלינו!
                </p>
              </div>
            );
          case enumTherapistsType.coach:
            return (
              <div>
                <h1 style={{ textAlign: 'center', color: '#4a80db' }}>
                  פגישה עם מאמן בריאות
                </h1>
                <p style={{ fontSize: '18px' }}>
                  חשיבות המשוב הינה גדולה ואף הכרחית על מנת להבין את הדו"ח
                  הרפואי שלך, ולקבל את הכלים הנדרשים ליישום ההמלצות.
                </p>
              </div>
            );

          case enumTherapistsType.doctor:
            return (
              <div>
                <h1 style={{ textAlign: 'center', color: '#4a80db' }}>
                  פגישה עם רופא
                </h1>
                <p style={{ fontSize: '18px' }}>
                  משוב עם הרופא/ה לאחר הדו"ח הינו חשוב ביותר כדי למקסם את המלצות
                  הדו"ח והמשך הטיפול.
                </p>
              </div>
            );

          default:
            return null;
        }
      })()}
    </>
  );
};
